import generateStore from './generateStore.js'
import { axios } from '../request'

export default (app) => {
  const store = generateStore('treasuryDocsStatuses', app)

  store.actions.createBulk = function (context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/treasury_docs_statuses/bulk', data)
        .then(() => {
          resolve()
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  store.actions.deleteBulk = function (context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post('/treasury_docs_statuses/bulk_delete', data)
        .then(() => {
          resolve()
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  return store
}
